import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { CreateOneShopExportDto, ShopDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";

type AddExportMethodParams = {
  shopExport: CreateOneShopExportDto;
};

type UseAddExportMethodParams = {
  onSuccess?: () => void;
};

export default function useAddExportMethod(
  shop: ShopDto,
  params?: UseAddExportMethodParams,
) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateShop(shop.id);

  const mutation = $api.useMutation("post", "/shops/{shopId}/exports");

  return useMutation({
    onSuccess: () => {
      params?.onSuccess?.();
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: async ({ shopExport }: AddExportMethodParams) => {
      return mutation.mutateAsync({
        params: { path: { shopId: shop.id } },
        body: shopExport,
      });
    },
  });
}
